import { Component, OnInit } from '@angular/core';
import { TensorflowModelService } from '../../services/tensorflow-model.service';

@Component({
  selector: 'app-tensorflow-test',
  templateUrl: './tensorflow-test.component.html',
  styleUrls: ['./tensorflow-test.component.scss']
})
export class TensorflowTestComponent implements OnInit {
  modelLoaded = false;
  modelInfo: any = null;
  inputData: string = '';
  predictionResult: any = null;
  loading = false;
  error: string = '';

  constructor(private tensorflowService: TensorflowModelService) { }

  async ngOnInit() {
    await this.loadModel();
  }

  async loadModel() {
    this.loading = true;
    this.error = '';
    
    try {
      // Cambia esta ruta según donde coloques tu modelo
      await this.tensorflowService.loadModel('assets/models/weights_web_model/model.json');
      this.modelLoaded = true;
      this.modelInfo = this.tensorflowService.getModelInfo();
      console.log('Información del modelo:', this.modelInfo);
    } catch (error: any) {
      this.error = 'Error al cargar el modelo: ' + error.message;
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  async predict() {
    if (!this.inputData) {
      this.error = 'Por favor ingresa datos de entrada';
      return;
    }

    this.loading = true;
    this.error = '';
    this.predictionResult = null;

    try {
      // Parsea los datos de entrada (espera un array JSON)
      const parsedInput = JSON.parse(this.inputData);
      
      // Realiza la predicción
      const result = await this.tensorflowService.predict(parsedInput);
      this.predictionResult = result;
      
      console.log('Resultado de la predicción:', result);
    } catch (error: any) {
      this.error = 'Error al realizar la predicción: ' + error.message;
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  async testWithRandomData() {
    this.loading = true;
    this.error = '';
    this.predictionResult = null;

    try {
      // Obtiene el shape esperado del modelo
      const inputShape = this.modelInfo?.inputs[0]?.shape;
      
      if (!inputShape) {
        this.error = 'No se pudo determinar el shape de entrada del modelo';
        return;
      }

      console.log('Generando datos aleatorios con shape:', inputShape);
      
      // Genera datos aleatorios basados en el shape
      // Reemplaza null/-1 con 1 para el batch size
      const actualShape = inputShape.map((dim: number | null) => 
        dim === null || dim === -1 ? 1 : dim
      );
      
      const randomData = this.generateRandomArray(actualShape);
      this.inputData = JSON.stringify(randomData);
      
      // Realiza la predicción
      await this.predict();
      
    } catch (error: any) {
      this.error = 'Error al generar datos aleatorios: ' + error.message;
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  private generateRandomArray(shape: number[]): any {
    if (shape.length === 1) {
      return Array.from({ length: shape[0] }, () => Math.random());
    }
    
    const [first, ...rest] = shape;
    return Array.from({ length: first }, () => this.generateRandomArray(rest));
  }
}
